import styled from 'styled-components';

const Clearfix = styled.img`
  height: 70px;
`;

export default Clearfix;
